import {hitGoogleTagManager} from "./hit_google_tag_manager";

export type GtmUserPhoneNumberEventAction = "view" | "click" | "fill" | "submit";

export const hitGtmUserPhoneNumber = (action: GtmUserPhoneNumberEventAction) => {
    const gtmData = {
        event: "price_unlock_phone",
        event_action: action
    };

    hitGoogleTagManager(gtmData);
};
import {hitGoogleTagManager} from "./hit_google_tag_manager";

export type GtmUserPhoneNumberEventAction = "view" | "click" | "fill" | "submit";

export const hitGtmUserPhoneNumber = (action: GtmUserPhoneNumberEventAction) => {
    const gtmData = {
        event: "price_unlock_phone",
        event_action: action
    };

    hitGoogleTagManager(gtmData);
};
